import { render } from "./loading.vue?vue&type=template&id=12e78298&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=12e78298&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e78298"]])

export default __exports__